(function () {
  'use strict';

  window.Axiom = window.Axiom || {};
  var standard = window.AxiomStandardStorefront = window.AxiomStandardStorefront || {};
  var activeCartEventTarget = null;
  var pageViewDispatched = false;

  function events() {
    return window.Shopify && window.Shopify.StandardEvents ? window.Shopify.StandardEvents : null;
  }

  function cartTarget() {
    return document.getElementById('cart-drawer') || document.querySelector('[data-cart-page]') || document.body || document;
  }

  function cartLines(cart) {
    if (!cart) return [];
    if (Array.isArray(cart.items)) {
      return cart.items.map(function (item) {
        var variantId = item.variant_id || item.id;
        var productId = item.product_id;
        return {
          id: item.key || item.id,
          quantity: item.quantity,
          merchandiseId: variantId ? 'gid://shopify/ProductVariant/' + variantId : '',
          merchandise: {
            id: variantId ? 'gid://shopify/ProductVariant/' + variantId : '',
            product: {
              id: productId ? 'gid://shopify/Product/' + productId : '',
              handle: item.handle || '',
              title: item.product_title || ''
            }
          },
          handle: item.handle || ''
        };
      });
    }
    if (!cart.lines) return [];
    if (Array.isArray(cart.lines)) return cart.lines;
    if (Array.isArray(cart.lines.nodes)) return cart.lines.nodes;
    if (Array.isArray(cart.lines.edges)) {
      return cart.lines.edges.map(function (edge) { return edge && edge.node; }).filter(Boolean);
    }
    return [];
  }

  function cartQuantity(cart) {
    if (!cart) return 0;
    if (Number.isFinite(Number(cart.totalQuantity))) return Number(cart.totalQuantity);
    if (Number.isFinite(Number(cart.item_count))) return Number(cart.item_count);
    return 0;
  }

  function firstMessage(items, fallback) {
    var item = Array.isArray(items) ? items[0] : null;
    return (item && (item.message || item.code)) || fallback || 'Cart update failed.';
  }

  function quantityLimitMessage(count) {
    var template = window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings.quantityLimitReached
      || 'You can only add [count] of this item to your bag.';
    var normalizedCount = Math.max(0, parseInt(count, 10) || 0);
    return String(template).replace('[count]', String(normalizedCount));
  }

  function createCartActionError(result, context) {
    var userErrors = result && Array.isArray(result.userErrors) ? result.userErrors : [];
    var primaryError = userErrors[0] || {};
    var detail = result && result.detail != null ? result.detail : context && context.detail;
    var requestTarget = context && context.target || activeCartEventTarget || null;
    var message = primaryError.message || primaryError.code || 'Cart update failed.';
    var error = new Error(message);

    error.name = 'AxiomCartActionError';
    error.code = primaryError.code || '';
    error.field = primaryError.field || null;
    error.userErrors = userErrors;
    error.detail = detail == null ? null : detail;
    error.source = context && context.source || result && result.source || detail && detail.source || '';
    error.requestTarget = requestTarget;
    error.target = requestTarget;
    error.result = result;

    return error;
  }

  function assertCartResult(result, context) {
    if (result && Array.isArray(result.userErrors) && result.userErrors.length) {
      throw createCartActionError(result, context || {});
    }
    return result;
  }

  function gid(type, value) {
    var id = String(value || '').trim();
    if (!id) return '';
    return id.indexOf('gid://') === 0 ? id : 'gid://shopify/' + type + '/' + id;
  }

  function attributes(properties) {
    return Object.keys(properties || {}).map(function (key) {
      return { key: key, value: String(properties[key] == null ? '' : properties[key]) };
    }).filter(function (attribute) {
      return attribute.key && attribute.value !== '';
    });
  }

  function addLineFromItem(item) {
    var line = {
      merchandiseId: gid('ProductVariant', item && (item.merchandiseId || item.id || item.variantId)),
      quantity: Math.max(1, parseInt(item && item.quantity, 10) || 1)
    };
    var lineAttributes = attributes(item && (item.attributes || item.properties));
    var sellingPlanId = gid('SellingPlan', item && (item.sellingPlanId || item.selling_plan));
    if (lineAttributes.length) line.attributes = lineAttributes;
    if (sellingPlanId) line.sellingPlanId = sellingPlanId;
    return line;
  }

  function drawerMode() {
    return !window.Axiom || (window.Axiom.cartType || 'drawer') === 'drawer';
  }

  function setLoading(loading) {
    var drawer = document.getElementById('cart-drawer');
    var page = document.querySelector('[data-cart-page]');
    if (drawer) drawer.classList.toggle('is-loading', Boolean(loading));
    if (page) page.classList.toggle('is-updating', Boolean(loading));
  }

  function withTarget(target, fn) {
    activeCartEventTarget = target && target.nodeType === 1 ? target : cartTarget();
    return Promise.resolve().then(fn).finally(function () {
      activeCartEventTarget = null;
    });
  }

  function standardEvents() {
    return events()
      ? Promise.resolve(events())
      : import('https://cdn.shopify.com/storefront/standard-events.js');
  }

  function cartLinesAction(lines) {
    if ((lines || []).some(function (line) { return line.merchandiseId && line.quantity > 0; })) return 'add';
    if ((lines || []).some(function (line) { return Number(line.quantity) === 0; })) return 'remove';
    return 'update';
  }

  function cartActionResult(StandardEvents, ajaxCart) {
    return {
      cart: StandardEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      userErrors: [],
      warnings: [],
      detail: { ajaxCart: ajaxCart }
    };
  }

  function updateCart(payload, options) {
    options = options || {};
    var requestTarget = options.target && options.target.nodeType === 1 ? options.target : cartTarget();
    return withTarget(requestTarget, function () {
      var lines = Array.isArray(payload.lines) ? payload.lines : [];
      var eventDetail = Object.assign({ source: options.source || '' }, options.detail || {});
      var mutation = function () { return ajaxCartMutation(payload, options); };

      if (!lines.length) {
        return mutation().then(function (ajaxCart) {
          return { cart: ajaxCart, userErrors: [], warnings: [], detail: { ajaxCart: ajaxCart } };
        });
      }

      return standardEvents().then(function (StandardEvents) {
        if (!StandardEvents.CartLinesUpdateEvent || typeof StandardEvents.CartLinesUpdateEvent.createPromise !== 'function') {
          return mutation().then(function (ajaxCart) {
            return { cart: ajaxCart, userErrors: [], warnings: [], detail: { ajaxCart: ajaxCart } };
          });
        }

        var deferred = StandardEvents.CartLinesUpdateEvent.createPromise();
        requestTarget.dispatchEvent(new StandardEvents.CartLinesUpdateEvent({
          action: cartLinesAction(lines),
          context: options.context || 'standard-action',
          lines: lines,
          detail: eventDetail,
          promise: deferred.promise
        }));

        return mutation().then(function (ajaxCart) {
          var result = cartActionResult(StandardEvents, ajaxCart);
          deferred.resolve(result);
          return result;
        }, function (error) {
          deferred.reject(error);
          throw error;
        });
      }).then(function (result) {
        if (result && Array.isArray(result.warnings) && result.warnings.length && typeof options.onWarning === 'function') {
          options.onWarning(firstMessage(result.warnings, ''), result);
        }
        assertCartResult(result, {
          source: options.source || '',
          target: requestTarget,
          detail: options.detail || null
        });
        if (window.AxiomFreeShippingBar && typeof window.AxiomFreeShippingBar.update === 'function' && result && result.detail && result.detail.ajaxCart) {
          window.AxiomFreeShippingBar.update(result.detail.ajaxCart);
        }
        return result && result.detail && result.detail.ajaxCart
          ? Object.assign({}, result, { cart: result.detail.ajaxCart })
          : result;
      });
    });
  }

  function openCart(returnFocus, cart) {
    if (!drawerMode()) {
      window.location.href = (window.Axiom && window.Axiom.routes && window.Axiom.routes.cart) || '/cart';
      return Promise.resolve();
    }
    if (window.Axiom && typeof window.Axiom.loadCartController === 'function') {
      return window.Axiom.loadCartController().then(function (controller) {
        // Opening is synchronous once the controller is available. Cart section
        // rendering continues in the background so the launcher never waits on
        // an Ajax cart read and the drawer keeps its focus trap responsive.
        if (controller && typeof controller.open === 'function') controller.open(returnFocus);
        if (!cart) return null;
        return renderCart(cart).then(function (renderedCart) {
          dispatchCartView(document.getElementById('cart-drawer'), renderedCart, 'dialog');
          return renderedCart;
        });
      });
    }
    return Promise.resolve();
  }

  function ajaxCartUrl(path) {
    var addUrl = window.Axiom && window.Axiom.routes && window.Axiom.routes.cart_add;
    if (path === 'add' && addUrl) return addUrl;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      || window.Axiom && window.Axiom.routes && window.Axiom.routes.root
      || '/';
    return String(root).replace(/\/?$/, '/') + (path === 'cart' ? 'cart.js' : 'cart/' + path + '.js');
  }

  function fetchAjaxCart() {
    return fetch(ajaxCartUrl('cart'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed (' + response.status + ').');
      return response.json();
    });
  }

  function cartDrawerSectionId() {
    var drawer = document.getElementById('cart-drawer');
    return drawer && drawer.dataset.sectionId || '';
  }

  function cartFromSection(html) {
    if (!html) return null;
    var drawer = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer');
    var state = drawer && drawer.querySelector('[data-cart-state]');
    if (!state) throw new Error('Bundled cart drawer did not include cart state.');
    return JSON.parse(state.textContent);
  }

  function currentRenderedCart() {
    var state = document.querySelector('#cart-drawer [data-cart-state]');
    return state ? JSON.parse(state.textContent) : null;
  }

  function mutationSections() {
    var sectionId = cartDrawerSectionId();
    return sectionId ? {
      sections: sectionId,
      sections_url: window.location.pathname + window.location.search
    } : {};
  }

  function postAjaxCart(path, body, options) {
    return fetch(ajaxCartUrl(path), {
      method: 'POST',
      credentials: 'same-origin',
      signal: options && options.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(Object.assign({}, body, mutationSections()))
    }).then(function (response) {
      return response.text().then(function (bodyText) {
        var payload = null;
        try { payload = JSON.parse(bodyText); } catch (error) {}
        if (response.ok && payload) return payload;
        var error = new Error(payload && (payload.description || payload.message) || 'Cart request failed (' + response.status + ').');
        error.status = response.status;
        error.payload = payload;
        throw error;
      });
    });
  }

  function rawShopifyId(value) {
    return String(value || '').split('/').pop();
  }

  function ajaxAddItem(line) {
    var item = {
      id: rawShopifyId(line.merchandiseId),
      quantity: line.quantity
    };
    if (Array.isArray(line.attributes) && line.attributes.length) {
      item.properties = {};
      line.attributes.forEach(function (attribute) {
        if (attribute && attribute.key) item.properties[attribute.key] = attribute.value;
      });
    }
    if (line.sellingPlanId) item.selling_plan = rawShopifyId(line.sellingPlanId);
    return item;
  }

  function discountCodesFromAjaxCart(cart) {
    var applications = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    var seen = new Set();
    return applications.filter(function (application) {
      if (!application || application.type !== 'discount_code' || !application.title) return false;
      var code = application.title.toLocaleLowerCase();
      if (seen.has(code)) return false;
      seen.add(code);
      return true;
    }).map(function (application) {
      return { code: application.title, applicable: true };
    });
  }

  function cartFromMutation(response, ajaxCart) {
    var sectionId = cartDrawerSectionId();
    var html = response && response.sections && response.sections[sectionId];
    if (sectionId && response && response.sections && !html) {
      throw new Error('Bundled cart drawer section failed to render.');
    }
    // Bundled Liquid and the mutation share one request/cart context. A later
    // cart.js read can be empty in the cross-site Theme Store preview iframe.
    var cart = Object.assign({}, cartFromSection(html) || ajaxCart);
    if (response && response.sections) cart.sections = response.sections;
    cart.discountCodes = discountCodesFromAjaxCart(cart);
    return cart;
  }

  function ajaxCartMutation(payload, options) {
    var lines = Array.isArray(payload.lines) ? payload.lines : [];
    var additions = lines.filter(function (line) { return line.merchandiseId && line.quantity > 0; });
    var changes = lines.filter(function (line) { return line.id; });
    var response = null;
    var task = Promise.resolve();

    if (additions.length) {
      task = task.then(function () {
        return postAjaxCart('add', { items: additions.map(ajaxAddItem) }, options);
      }).then(function (result) { response = result; });
    }
    changes.forEach(function (line) {
      task = task.then(function () {
        return postAjaxCart('change', { id: line.id, quantity: line.quantity }, options);
      }).then(function (result) { response = result; });
    });
    if (Object.prototype.hasOwnProperty.call(payload, 'note') ||
        Object.prototype.hasOwnProperty.call(payload, 'discountCodes') ||
        Object.prototype.hasOwnProperty.call(payload, 'attributes')) {
      var update = {};
      if (Object.prototype.hasOwnProperty.call(payload, 'note')) update.note = payload.note;
      if (Object.prototype.hasOwnProperty.call(payload, 'discountCodes')) update.discount = payload.discountCodes.join(',');
      if (Object.prototype.hasOwnProperty.call(payload, 'attributes')) {
        update.attributes = {};
        payload.attributes.forEach(function (attribute) { update.attributes[attribute.key] = attribute.value; });
      }
      task = task.then(function () { return postAjaxCart('update', update, options); })
        .then(function (result) { response = result; });
    }

    return task.then(function () {
      if (!response) return fetchAjaxCart();
      if (response.sections && cartDrawerSectionId()) {
        return cartFromMutation(response);
      }
      if (Number.isFinite(Number(response.item_count))) return cartFromMutation(response, response);
      return fetchAjaxCart().then(function (cart) { return cartFromMutation(response, cart); });
    });
  }

  function prepareProductFormData(form) {
    var formData = new FormData(form);
    Array.prototype.slice.call(form.querySelectorAll('input[type="file"]')).forEach(function (input) {
      if (!input.name || (input.files && input.files.length)) return;
      formData.delete(input.name);
    });
    return formData;
  }

  function addProductForm(form, options) {
    options = options || {};
    if (!form) return Promise.reject(new Error(options.emptyMessage || 'No available products to add.'));

    var formData = prepareProductFormData(form);
    var bundled = mutationSections();
    if (bundled.sections) {
      formData.set('sections', bundled.sections);
      formData.set('sections_url', bundled.sections_url);
    }
    if (drawerMode() && !options.redirectToCheckout) setLoading(true);

    return fetch(ajaxCartUrl('add'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          var error = new Error((payload && (payload.description || payload.message)) || 'Cart request failed.');
          error.status = response.status;
          error.payload = payload;
          throw error;
        }
        if (payload.sections && cartDrawerSectionId()) {
          return cartFromMutation(payload);
        }
        return fetchAjaxCart().then(function (cart) { return cartFromMutation(payload, cart); });
      });
    }).then(function (cart) {
      if (window.Axiom && typeof window.Axiom.updateCartCount === 'function') {
        window.Axiom.updateCartCount(cartQuantity(cart));
      }
      if (window.AxiomFreeShippingBar && typeof window.AxiomFreeShippingBar.update === 'function') {
        window.AxiomFreeShippingBar.update(cart);
      }
      var renderPromise = window.Axiom && window.Axiom.cart && typeof window.Axiom.cart.renderStandard === 'function'
        ? Promise.resolve(window.Axiom.cart.renderStandard(cart))
        : Promise.resolve(cart);
      if (window.Axiom && window.Axiom.cartPage && typeof window.Axiom.cartPage.renderStandard === 'function') {
        renderPromise = renderPromise.then(function () {
          return window.Axiom.cartPage.renderStandard(cart);
        });
      }
      return renderPromise.then(function () {
        if (options.redirectToCheckout) {
          window.location.href = (window.Axiom && window.Axiom.routes && window.Axiom.routes.checkout) || '/checkout';
          return { cart: cart };
        }
        if (drawerMode() && window.Axiom && window.Axiom.cart && typeof window.Axiom.cart.open === 'function') {
          window.Axiom.cart.open(options.returnFocus || document.activeElement);
        }
        return { cart: cart };
      });
    }).finally(function () {
      if (!options.redirectToCheckout) setLoading(false);
    });
  }

  function addLines(items, options) {
    options = options || {};
    var lines = (Array.isArray(items) ? items : [items])
      .filter(Boolean)
      .map(addLineFromItem)
      .filter(function (line) { return line.merchandiseId && line.quantity > 0; });

    if (!lines.length) {
      return Promise.reject(new Error(options.emptyMessage || 'No available products to add.'));
    }

    if (drawerMode()) {
      setLoading(true);
    }

    return updateCart({ lines: lines }, Object.assign({}, options, {
      context: options.context || 'product'
    })).finally(function () {
      setLoading(false);
    });
  }

  function updateLine(lineId, quantity, options) {
    var id = String(lineId || '').trim();
    if (!id) return Promise.reject(new Error('Missing cart line id.'));
    setLoading(true);
    return updateCart({ lines: [{ id: id, quantity: Math.max(0, parseInt(quantity, 10) || 0) }] }, Object.assign({}, options, {
      context: options && options.context || 'cart'
    })).finally(function () {
      setLoading(false);
    });
  }

  function updateNote(note, options) {
    setLoading(true);
    return updateCart({ note: note || '' }, Object.assign({}, options, {
      context: options && options.context || 'cart'
    })).finally(function () {
      setLoading(false);
    });
  }

  function updateDiscounts(discountCodes, options) {
    var codes = Array.isArray(discountCodes) ? discountCodes : [discountCodes];
    setLoading(true);
    return updateCart({ discountCodes: codes.filter(Boolean) }, Object.assign({}, options, {
      context: options && options.context || 'cart'
    })).finally(function () {
      setLoading(false);
    });
  }

  function getCart() {
    var rendered = currentRenderedCart();
    return (rendered ? Promise.resolve(rendered) : fetchAjaxCart()).then(function (cart) {
      cart.discountCodes = discountCodesFromAjaxCart(cart);
      return cart;
    });
  }

  function refreshCart() {
    var sectionId = cartDrawerSectionId();
    if (!sectionId) return fetchAjaxCart();
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart drawer section failed to refresh (' + response.status + ').');
      return response.text();
    }).then(function (html) {
      var cart = cartFromSection(html);
      cart.sections = {};
      cart.sections[sectionId] = html;
      cart.discountCodes = discountCodesFromAjaxCart(cart);
      return cart;
    });
  }

  function clearCart(options) {
    setLoading(true);
    return postAjaxCart('clear', {}, options).then(function (response) {
      var cart = cartFromMutation(response, response);
      if (window.AxiomFreeShippingBar && typeof window.AxiomFreeShippingBar.update === 'function') {
        window.AxiomFreeShippingBar.update(cart);
      }
      return { cart: cart };
    }).finally(function () {
      setLoading(false);
    });
  }

  function renderCart(cart) {
    if (window.Axiom && typeof window.Axiom.updateCartCount === 'function') {
      window.Axiom.updateCartCount(cartQuantity(cart));
    }
    var tasks = [];
    if (window.Axiom && window.Axiom.cart && typeof window.Axiom.cart.renderStandard === 'function') {
      tasks.push(window.Axiom.cart.renderStandard(cart));
    }
    if (window.Axiom && window.Axiom.cartPage && typeof window.Axiom.cartPage.renderStandard === 'function') {
      tasks.push(window.Axiom.cartPage.renderStandard(cart));
    }
    return Promise.all(tasks).then(function () { return cart; });
  }

  function dispatchCartView(target, cart, context) {
    var SE = events();
    if (!SE || !SE.CartViewEvent || !target) return;
    var eventCart = cart && Array.isArray(cart.items) && typeof SE.CartViewEvent.createCartFromAjaxResponse === 'function'
      ? SE.CartViewEvent.createCartFromAjaxResponse(cart)
      : cart || null;
    target.dispatchEvent(new SE.CartViewEvent({
      context: context || 'dialog',
      cart: eventCart
    }));
  }

  function handleError(error) {
    console.error('Cart action error:', error);
    document.querySelectorAll('[data-atc-btn].loading, [data-featured-atc].loading').forEach(function (button) {
      button.classList.remove('loading');
    });
    document.querySelectorAll('[data-qv-atc][data-loading="true"]').forEach(function (button) {
      button.dataset.loading = 'false';
      button.disabled = false;
    });
  }

  function handleCartEvent(event) {
    if (!event || !event.promise) return;
    var source = event.detail && event.detail.source || '';
    if (source === 'cart-page' || source === 'cart-drawer') return;
    var returnFocus = document.activeElement && document.activeElement.nodeType === 1
      ? document.activeElement
      : null;
    var quickView = returnFocus && returnFocus.closest
      ? returnFocus.closest('[data-quick-view-modal]')
      : null;
    if (quickView && quickView._quickViewReturnFocus && quickView._quickViewReturnFocus.isConnected) {
      returnFocus = quickView._quickViewReturnFocus;
    }
    setLoading(true);
    event.promise
      .then(function (result) {
        assertCartResult(result, {
          source: event.detail && event.detail.source || '',
          target: event.target && event.target.nodeType === 1 ? event.target : activeCartEventTarget,
          detail: event.detail || null
        });
        var cart = result.detail && result.detail.ajaxCart || result.cart;
        var keepSourceDrawerOpen = Boolean(event.detail && event.detail.keepSourceDrawerOpen);
        if (event.type === 'shopify:cart:lines-update' && event.action === 'add' && drawerMode() && !keepSourceDrawerOpen) {
          return openCart(returnFocus, cart);
        }
        return renderCart(cart);
      })
      .catch(handleError)
      .finally(function () {
        setLoading(false);
      });
  }

  function dispatchPageView() {
    var SE = events();
    if (!SE || !SE.PageViewEvent || pageViewDispatched || document.readyState === 'loading') return;
    pageViewDispatched = true;
    document.dispatchEvent(new SE.PageViewEvent({
      page: {
        template: document.body ? String(document.body.className || '').split(/\s+/).find(function (name) {
          return name.indexOf('template-') === 0;
        }) || '' : '',
        title: document.title,
        url: window.location.href
      }
    }));
  }

  function optionPayload(variant) {
    return (variant && Array.isArray(variant.options) ? variant.options : []).map(function (value, index) {
      return { name: 'Option ' + (index + 1), value: String(value || '') };
    });
  }

  function dispatchProductSelect(target, product, variant) {
    var SE = events();
    if (!SE || !SE.ProductSelectEvent) return;
    var selectedOptions = optionPayload(variant);
    var deferred = typeof SE.ProductSelectEvent.createPromise === 'function' ? SE.ProductSelectEvent.createPromise() : null;
    (target || document).dispatchEvent(new SE.ProductSelectEvent({
      selectedOptions: selectedOptions,
      product: {
        id: product && product.id,
        title: product && product.title,
        handle: product && product.handle
      },
      promise: deferred ? deferred.promise : undefined
    }));
    if (deferred) {
      deferred.resolve({
        variant: variant ? {
          id: variant.id,
          title: variant.title,
          availableForSale: Boolean(variant.available),
          selectedOptions: selectedOptions
        } : null
      });
    }
  }

  function dispatchCollectionUpdate(target, promise, url) {
    var SE = events();
    if (!SE || !SE.CollectionUpdateEvent || !target) return;
    var currentUrl = url || new URL(window.location.href);
    target.dispatchEvent(new SE.CollectionUpdateEvent({
      collection: {
        id: target.dataset.collectionId || null,
        handle: target.dataset.collectionHandle || '',
        productsCount: Number(target.dataset.productsCount || 0) || null
      },
      productFilters: typeof SE.CollectionUpdateEvent.parseProductFilters === 'function' ? SE.CollectionUpdateEvent.parseProductFilters(currentUrl.searchParams) : undefined,
      sortKey: typeof SE.CollectionUpdateEvent.getSortKey === 'function'
        ? SE.CollectionUpdateEvent.getSortKey(currentUrl.searchParams)
        : undefined,
      promise: promise
    }));
  }

  function dispatchSearchUpdate(target, promise, url) {
    var SE = events();
    if (!SE || !SE.SearchUpdateEvent || !target) return;
    var currentUrl = url || new URL(window.location.href);
    target.dispatchEvent(new SE.SearchUpdateEvent({
      search: {
        query: currentUrl.searchParams.get('q') || '',
        productFilters: typeof SE.SearchUpdateEvent.parseProductFilters === 'function' ? SE.SearchUpdateEvent.parseProductFilters(currentUrl.searchParams) : undefined,
        sortKey: typeof SE.SearchUpdateEvent.getSortKey === 'function'
          ? SE.SearchUpdateEvent.getSortKey(currentUrl.searchParams)
          : undefined
      },
      promise: promise
    }));
  }

  document.addEventListener('DOMContentLoaded', dispatchPageView);
  document.addEventListener('shopify:cart:lines-update', handleCartEvent);
  document.addEventListener('shopify:cart:note-update', handleCartEvent);
  document.addEventListener('shopify:cart:discount-update', handleCartEvent);
  document.addEventListener('shopify:cart:error', function (event) {
    handleError(event && (event.error || event.detail && event.detail.error || event));
  });

  standard.getCartEventTarget = function () {
    if (activeCartEventTarget && activeCartEventTarget.isConnected) return activeCartEventTarget;
    return cartTarget();
  };
  standard.getCartLines = cartLines;
  standard.getCartTotalQuantity = cartQuantity;
  standard.quantityLimitMessage = quantityLimitMessage;
  standard.getLineIdFromControl = function (control) {
    var item = control && control.closest ? control.closest('[data-cart-line-id]') : null;
    return String((control && control.dataset.cartLineId) || (item && item.dataset.cartLineId) || '').trim();
  };
  standard.addLines = addLines;
  standard.addProductForm = addProductForm;
  standard.updateCart = updateCart;
  standard.updateLine = updateLine;
  standard.updateNote = updateNote;
  standard.updateDiscounts = updateDiscounts;
  standard.clearCart = clearCart;
  standard.getCart = getCart;
  standard.fetchCart = fetchAjaxCart;
  standard.refreshCart = refreshCart;
  standard.openCart = openCart;
  standard.renderCart = renderCart;
  standard.dispatchCartView = dispatchCartView;
  standard.dispatchPageView = dispatchPageView;
  standard.dispatchProductSelect = dispatchProductSelect;
  standard.dispatchCollectionUpdate = dispatchCollectionUpdate;
  standard.dispatchSearchUpdate = dispatchSearchUpdate;
})();
